/* TERAVIA — odstránenie nezmyselných hodnôt typu „Neuvedená“ */
(() => {
  const isEmptyValue = (value) => {
    const text = String(value || '').trim().toLowerCase();
    return !text ||
      text.includes('neuveden') ||
      text.includes('not specified') ||
      text === 'n/a' ||
      text === 'na' ||
      text === 'undefined' ||
      text === 'null' ||
      text === '-';
  };

  const clean = (root = document) => {
    root.querySelectorAll('[data-product-card]').forEach((card) => {
      ['height', 'width', 'shape'].forEach((key) => {
        if (isEmptyValue(card.dataset[key])) card.dataset[key] = '';
      });
    });

    root.querySelectorAll('.product-meta span').forEach((item) => {
      if (isEmptyValue(item.textContent)) item.remove();
    });

    root.querySelectorAll('.product-meta').forEach((meta) => {
      meta.hidden = !meta.querySelector('span');
    });

    root.querySelectorAll('[data-quick-height], [data-quick-width], [data-quick-shape]').forEach((item) => {
      const row = item.closest('div');
      if (isEmptyValue(item.textContent)) {
        if (row) row.hidden = true;
      } else if (row) {
        row.hidden = false;
      }
    });
  };

  let queued = false;
  const scheduleClean = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      clean();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleClean, { once: true });
  } else {
    scheduleClean();
  }

  new MutationObserver(scheduleClean).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
